import { render, staticRenderFns } from "./PaymentManual.vue?vue&type=template&id=296bec89&"
import script from "./PaymentManual.vue?vue&type=script&lang=js&"
export * from "./PaymentManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports